import React from "react";
import "./App.css";
import MainPage from "./MainPage";
import { BrowserRouter } from "react-router-dom";
import { useToast } from "./hooks/custom/useToast";
import { LoaderProvider } from "./context/LoaderContext";
import { CompanyDetailsProvider } from "./context/CompanyDetailsContext";
import { BrochureProvider } from "./context/BrochureContext";

function App() {
  return (
    <>
      <BrochureProvider>
        <CompanyDetailsProvider>
          <LoaderProvider>
            <BrowserRouter>
              <MainPage />
            </BrowserRouter>
          </LoaderProvider>
        </CompanyDetailsProvider>
      </BrochureProvider>
      {useToast()}
    </>
  );
}

export default App; 
